import { QueryClient } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { client } from './client/client.gen';
import { useStore } from './store';
import { showToast } from './lib';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 30000,
			structuralSharing: false,
		},
	},
});

client.setConfig({ credentials: 'include' });

client.interceptors.request.use((request) => {
	request.headers.set('X-CSRFToken', Cookies.get('csrftoken') ?? '');
	return request;
});

client.interceptors.response.use(async(response, request) => {
  if (response.status !== 200) {
    // Detect request method
    const requestMethod = request.method; // 'GET', 'POST', 'PUT', etc.
    const { errors } = useStore.getState()
    // Clone the response before reading its body to avoid consuming the stream
    const resData = await response.clone().json()
    const msgCode = resData?.message || resData?.error
    // You can now handle different methods differently
    if (requestMethod === 'POST') {
      showToast(errors?.[msgCode] || errors?.[msgCode] || `Hệ thống chưa thể thực hiện yêu cầu của bạn: ${msgCode}`)
    } else if (requestMethod === 'GET') {
      // Handle GET-specific logic
    }
  }
  return response;
});